import api from '@/utils/axios';

const unwrap = (response, fallbackMessage) => {
  if (!response.data?.success) {
    const err = new Error(response.data?.error?.message || fallbackMessage);
    err.code = response.data?.error?.code;
    throw err;
  }
  return response.data.data;
};

/** Admin: list drivers-role users (includes disabled). */
export const listSettingsUsers = async ({ search = '' } = {}) => {
  const response = await api.post('settings/users/list', { search: search || undefined });
  return unwrap(response, 'Failed to load users');
};

/** Admin: create or update a drivers user. */
export const saveSettingsUser = async (payload) => {
  const response = await api.post('settings/users/save', payload);
  return unwrap(response, 'Failed to save user');
};

/** Admin: list termination reasons (includes inactive by default). */
export const listTermReasons = async ({ includeInactive = true } = {}) => {
  const response = await api.post('settings/term-reasons/list', { includeInactive });
  return unwrap(response, 'Failed to load termination reasons');
};

/** Admin: create or update a termination reason. */
export const saveTermReason = async (payload) => {
  const response = await api.post('settings/term-reasons/save', payload);
  return unwrap(response, 'Failed to save termination reason');
};

/** Admin: list lead sources (includes inactive by default). */
export const listLeadSources = async ({ includeInactive = true } = {}) => {
  const response = await api.post('settings/lead-sources/list', { includeInactive });
  return unwrap(response, 'Failed to load lead sources');
};

/** Admin: create or update a lead source. */
export const saveLeadSource = async (payload) => {
  const response = await api.post('settings/lead-sources/save', payload);
  return unwrap(response, 'Failed to save lead source');
};

/** Admin: list terminals (includes inactive by default). */
export const listTerminals = async ({ includeInactive = true } = {}) => {
  const response = await api.post('settings/terminals/list', { includeInactive });
  return unwrap(response, 'Failed to load terminals');
};

/** Admin: create or update a terminal. */
export const saveTerminal = async (payload) => {
  const response = await api.post('settings/terminals/save', payload);
  return unwrap(response, 'Failed to save terminal');
};

/** Admin: list company assignments grouped by W-2 / W-9 / other. */
export const listCompanies = async ({ includeInactive = true } = {}) => {
  const response = await api.post('settings/companies/list', { includeInactive });
  return unwrap(response, 'Failed to load company assignments');
};

/** Admin: create or update a company assignment. */
export const saveCompany = async (payload) => {
  const response = await api.post('settings/companies/save', payload);
  return unwrap(response, 'Failed to save company assignment');
};
